import type { IThirdPartyAuthFailReasons } from '@nerdwallet/js-auth-tools/registration';
import appConfig from '@nerdwallet/app-config';
import { HIDE_REG_STATUS } from './constants';
import type { SegmentTrackingAttributes } from '../lib/helpers';
import type { HeaderOptions } from '../../../types';

interface AbTest {
  __typename: string;
  assignedVariant: string;
  assignedVariantName: string;
  experimentId: string;
  experimentName: string;
  isForcedVariant: boolean;
  rampNum: number;
  usesEEE: boolean;
  variants: Array<Variants>;
}

interface Variants {
  __typename: string;
  customData: any;
  variantId: string;
  variantName: string;
}

interface MenuItem {
  title: string;
  uri: string;
}

interface FeatureFlag<T> {
  name: string;
  value: boolean;
  extraData: T;
}

export interface ReduxStore {
  firstName: string;
  isLoggedIn: boolean;
  pageVertical: string;
  // todo: type this
  pageTaxonomy: Array<any>;
  clientID: string;
  originatingUrl: string;
  windowSize: {
    width: number;
    height: number;
  };
  activeRegStatusNotification: {
    status: string;
    reason?: IThirdPartyAuthFailReasons;
    analytics?: {
      // eslint-disable-next-line camelcase
      trk_location: string;
      // eslint-disable-next-line camelcase
      trk_format: string;
    };
  };
  savedArticlesMenuItem: FeatureFlag<MenuItem>;
  areWebPushNotificationsActive: boolean;
  nerdWalletPlusActive: boolean;
  creditBuilderLoanActive: boolean;
  abTests: Array<AbTest>;
  experiments: Array<any>;
  segmentTrackingAttributes: SegmentTrackingAttributes;
  authParamsOverride?: HeaderOptions['authParamsOverride'];
  nerdWalletPlusFeatureDiscovery: boolean;
}

export const initialStore: ReduxStore = {
  firstName: '',
  isLoggedIn: false,
  pageVertical: '',
  pageTaxonomy: [],
  clientID: '',
  originatingUrl: '',
  windowSize: {
    width: 0,
    height: 0,
  },
  activeRegStatusNotification: { status: HIDE_REG_STATUS },
  savedArticlesMenuItem: {
    value: false,
    name: '',
    extraData: { title: '', uri: '' },
  },
  areWebPushNotificationsActive: false,
  nerdWalletPlusActive: false,
  creditBuilderLoanActive: false,
  abTests: [],
  experiments: [],
  segmentTrackingAttributes: {
    driverPageName: '',
    // eslint-disable-next-line no-underscore-dangle
    deployableName: appConfig?._meta?.deployable,
    // eslint-disable-next-line no-underscore-dangle
    deployableVersion: appConfig?._meta?.version,
    driverPageViewId: '',
    driverContentId: '',
    driverContentSource: '',
    driverFlowName: '',
  },
  nerdWalletPlusFeatureDiscovery: false,
};
